module.exports = __webpack_public_path__ + "static/media/file-image.ebb282e4.svg";